<template>
  <div class="w-full">
    <vs-list v-if="value.length > 0 && list">
      <vs-list-header :title="title"></vs-list-header>
      <vue-perfect-scrollbar
        class="scroll-area"
        :settings="settings"
        :style="{ position:' relative', 'max-height': maxHeight }"
      >
        <vs-list-item
          :title="`${item.name}`"
          v-for="(item, i) in value"
          :key="i"
        >
          <vs-button
            color="danger"
            type="flat"
            icon-pack="feather"
            icon="icon-x"
            @click="removeItem(i)"
          ></vs-button>
        </vs-list-item>
      </vue-perfect-scrollbar>
    </vs-list>
    <input
      style="display: none"
      ref="fileUpload"
      type="file"
      hidden
      :multiple="multiple"
      :accept="accept"
      @change="handleFileChange"
    />
    <vs-button
      :color="btnColor"
      :type="btnType"
      :class="btnClass"
      icon-pack="feather"
      icon="icon-upload"
      :disabled="disabled"
      @click="$refs.fileUpload.click()"
    >
      {{ btnText  }} {{ value.length > 0 && list === false ? `(${value.length})`:''}}
    </vs-button>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    btnColor: {
      type: String,
      default: 'primary'
    },
    btnType: {
      type: String,
      default: 'filled'
    },
    btnText: {
      type: String,
      default: 'Upload'
    },
    btnClass: {
      type: String,
      default: 'w-full'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    list: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: '200px'
    },
    accept:{
      type:String
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  data: () => ({
    settings: {
      maxScrollbarLength: 60
    }
  }),
  computed: {
    title () {
      return `${this.$i18n.messages[this.$i18n.locale].files} (${this.value.length})`
    }
  },
  watch: {
    value (val) {
      if (val === []) {
        this.$refs.fileUpload.value = ''
      }
    }
  },
  methods: {
    removeItem (i) {
      this.value.splice(i, 1)
    },
    handleFileChange (e) {
      const newItems = Array.prototype.slice.call(e.target.files)
      this.$emit('input', [...newItems])
      this.$refs.fileUpload.value = ''
    },
    chooseFiles () {
      this.$refs.fileUpload[0].click()
    }
  }
}
</script>
